import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { Progress } from 'Packages/FacetDesign/Components/Progress';
import { FDLabelText } from '@facet-wealth/design';

const DocumentUploadOverride = buildFacetDesignOverride()
  .nameOverride('progressPercent', {
    _component: () => Progress,
    _customProps: {
      label: '',
    },
  }, overrideReadOnly)
  .nameOverride('progressDetail', {
    _component: () => FDLabelText,
  }, overrideReadOnly);

export default DocumentUploadOverride;
